import React, { createContext, useContext } from "react";
import { MCSContext } from "../MCS.context";
import { getMrqData, getMrqPos, getMrqs } from "../api";
import { getMrqBid } from "./api";
import { getBidTableRows } from "./BidTable/BidTableBody/getRows";

const BidContext = createContext({
  vendors: [],
  setVendors: () => {},

  openChatVendorIndex: [],
  setOpenChatVendorIndex: () => {},
});

export const useBidContext = () => useContext(BidContext);

function BidContextProvider({ children }) {
  const [openChatVendorIndex, setOpenChatVendorIndex] = React.useState("");
  const { project, setSelectedBidMrqData } = React.useContext(MCSContext);

  const mrqData = project.selectedBidMrq;

  const [mrqList, setMrqList] = React.useState([]);
  const [mrqSelection, setMrqSelection] = React.useState({
    selectedMrq: "",
    revisions: [],
    selectedRevision: "",
  });
  const [BidTableRows, setBidTableRows] = React.useState();
  const [bidData, setBidData] = React.useState();
  const [selectedBidVendors, setSelectedVendors] = React.useState([]);

  React.useEffect(() => {
    const fetchMrqList = async () => {
      await getMrqs({ projectId: project.id }).then((res) => setMrqList(res));
    };

    fetchMrqList();
  }, []);

  React.useEffect(() => {
    setSelectedVendors(mrqData?.vendors?.map((v) => v.name));
  }, [mrqData?.vendors]);

  React.useEffect(() => {
    const revisions = mrqData?.revs ? mrqData.revs : [];

    setMrqSelection({
      selectedMrq: mrqData?.id,
      revisions,
      selectedRevision: mrqData?.id,
    });
  }, [mrqData?.id]);

  React.useEffect(() => {
    const fetchMrqThenBidData = async () => {
      if (mrqSelection.selectedMrq) {
        const mrq = await getMrqData(
          mrqSelection.selectedRevision || mrqSelection.selectedMrq
        );

        const bids = await getMrqBid(
          mrqSelection.selectedRevision || mrqSelection.selectedMrq
        );
        const existedPos = await getMrqPos(
          mrqSelection.selectedRevision || mrqSelection.selectedMrq
        );
        setBidData(bids ? bids : []);
        // console.log({ mrqData, bids });
        // setBidTableRows([]);

        setBidTableRows(
          getBidTableRows({
            mrqData: mrq, //? project.selectedBidMrq : {},
            bidData: bids ? bids : [],
            existedPos,
            project,
          })
        );

        setSelectedBidMrqData({
          ...mrq,
          BidTableRows: getBidTableRows({
            mrqData: mrq,
            bidData: bids ? bids : [],
            existedPos,
            project,
          }),
        });
      }
    };

    fetchMrqThenBidData();
  }, [mrqSelection.selectedRevision, mrqSelection.selectedMrq]);

  const vendors = project?.selectedMrq?.vendors;
  return (
    <BidContext.Provider
      value={{
        vendors: vendors || [],
        openChatVendorIndex,
        setOpenChatVendorIndex,

        mrqData: project.selectedBidMrq,
        mrqList,
        mrqSelection,
        setMrqSelection,
        setSelectedBidMrqData,

        bidData,
        BidTableRows,
        setBidTableRows,

        selectedBidVendors,
        setSelectedVendors,
      }}
    >
      {children}
    </BidContext.Provider>
  );
}

export { BidContextProvider, BidContext };
